import { jsx as _jsx } from "react/jsx-runtime";
import tw from "tailwind-styled-components";
// Outer wrapper
export const PropertyRowContainer = tw.div`
	${({ $size })=>$size === "lg" ? "grow" : $size === "md" ? `w-[185px]` : "w-[80px]"}
	
	mb-1
	h-7
`;
// Used the for right-hand side of the property row
const PropertyRowOptions = ({ children, onClick, readOnly })=>/*#__PURE__*/ _jsx("div", {
        className: readOnly ? "cursor-pointer" : "",
        onClick: onClick,
        children: /*#__PURE__*/ _jsx("div", {
            className: readOnly ? "pointer-events-none" : "",
            children: children
        })
    });
const PropertyRowLabel = ({ children })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "",
        children: children
    });
};
const PropertyRow = ({ $size = "lg", $flipX = false, children })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: `grid ${$flipX ? "grid-cols-[1fr,auto]" : "grid-cols-[auto,1fr]"} gap-2 group/row relative items-start`,
        children: children
    });
};
PropertyRow.Options = PropertyRowOptions;
PropertyRow.Label = PropertyRowLabel;
export default PropertyRow;
